import React, { useState } from 'react';
import { FiLock, FiUser, FiArrowRight } from 'react-icons/fi';

const Login = ({ onLogin }) => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    const result = onLogin(username, password);
    if (!result.success) {
      setError(result.message || 'Login failed');
      setSubmitting(false);
    } else {
      // Small delay for animation to play
      setTimeout(() => setSubmitting(false), 400);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-600 via-indigo-600 to-purple-600 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white/10 backdrop-blur-lg border border-white/20 rounded-2xl p-8 shadow-2xl text-white animate-fade-up">
        <div className="flex items-center justify-center space-x-3 mb-6">
          <div className="h-10 w-10 rounded-full bg-white/20 flex items-center justify-center">
            <FiLock size={22} />
          </div>
          <div>
            <p className="text-sm uppercase tracking-wide text-white/70">Admin Access</p>
            <h1 className="text-2xl font-semibold">Tailor Control Room</h1>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="text-sm text-white/80">Username</label>
            <div className="mt-2 flex items-center bg-white/10 rounded-lg px-3 py-2 border border-white/10 focus-within:border-white/50">
              <FiUser className="text-white/70" />
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="shahroz"
                className="w-full bg-transparent focus:outline-none text-white placeholder-white/50 px-2"
              />
            </div>
          </div>

          <div>
            <label className="text-sm text-white/80">Password</label>
            <div className="mt-2 flex items-center bg-white/10 rounded-lg px-3 py-2 border border-white/10 focus-within:border-white/50">
              <FiLock className="text-white/70" />
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="•••"
                className="w-full bg-transparent focus:outline-none text-white placeholder-white/50 px-2"
              />
            </div>
          </div>

          {error && (
            <div className="text-sm text-red-100 bg-red-500/30 border border-red-200/50 rounded-lg px-3 py-2">
              {error}
            </div>
          )}

          <button
            type="submit"
            disabled={submitting}
            className="w-full bg-white text-primary-600 font-semibold py-3 rounded-lg hover:-translate-y-0.5 transform transition shadow-lg hover:shadow-2xl flex items-center justify-center space-x-2 disabled:opacity-70"
          >
            {submitting ? (
              <>
                <div className="h-4 w-4 border-2 border-primary-500 border-t-transparent rounded-full animate-spin" />
                <span>Authenticating...</span>
              </>
            ) : (
              <>
                <span>Enter</span>
                <FiArrowRight />
              </>
            )}
          </button>

          <p className="text-center text-xs text-white/70 mt-2">Hint: admin: shahroz/123 • user: user/123</p>
        </form>
      </div>
    </div>
  );
};

export default Login;


